import React from 'react';
import styled from 'styled-components/macro';
import { faCameraRetro, faFilm, faSignIn, faSmileWink, faStars, faWebcam } from '@fortawesome/pro-light-svg-icons';
import { faHome } from '@fortawesome/pro-regular-svg-icons';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { FOOTER_DISCOUNTS, FOOTER_MOBILE_NAV } from 'src/client/constants/joinCampaigns';
import { useGenerateCamUrlWithParams } from 'src/client/helpers/urls/useGenerateCamUrlWithParams';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { getFooterMenuItemEligibility } from './footerMenuEligibility';
import { MobileFooterNavButton } from './MobileFooterNavButton';
import { MobileFooterNavSlot } from './MobileFooterNavSlot';

export const MobileFooterNav = () => {
  const config = useSelector((state) => state.app.config);
  const user = useSelector((state) => state.auth.user);
  const [discountJoinUrl] = useJoinUrl({ campaign: FOOTER_DISCOUNTS });
  const [footerJoinUrl] = useJoinUrl({ campaign: FOOTER_MOBILE_NAV });

  const generateCamUrlWithParams = useGenerateCamUrlWithParams({
    trackingPosition: 'mobileFooterNav',
    provider: config?.camProviders?.[0].provider ?? 'streamate',
  });

  const hasUser = Boolean(user);

  const eligibility = getFooterMenuItemEligibility({
    hasUser,
    configMoviesActive: Boolean(config.movies?.active),
    configMoviesRequiresAuth: Boolean(config.movies?.requiresAuth),
  });

  return (
    <MobileFooterNavContainer aria-label="Mobile footer navigation">
      <MobileFooterNavSlot slotId="home">
        <MobileFooterNavButton to="/updates" icon={faHome} label="Home" />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="films" isVisible={Boolean(eligibility.films)}>
        <MobileFooterNavButton to="/erotic-films" icon={faFilm} label="Films" />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="photos" isVisible={!eligibility.films}>
        <MobileFooterNavButton to="/galleries" icon={faCameraRetro} label="Photos" />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="models">
        <MobileFooterNavButton to="/models" icon={faStars} label="Models" />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="discounts" isVisible={hasUser}>
        <MobileFooterNavButton to={discountJoinUrl} icon={faSmileWink} label="Discounts" openInNewWindow />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="cams">
        <MobileFooterNavButton
          to={generateCamUrlWithParams('/cams-list')}
          icon={faWebcam}
          label="Cams"
          openInNewWindow
        />
      </MobileFooterNavSlot>

      <MobileFooterNavSlot slotId="join" isVisible={!hasUser}>
        <SignupNavButton to={footerJoinUrl} icon={faSignIn} label="Join" openInNewWindow />
      </MobileFooterNavSlot>
    </MobileFooterNavContainer>
  );
};

const MobileFooterNavContainer = styled.nav`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 65px;
  z-index: 900;
  background: ${(props) => props.theme.headerBarPrimary1};
  border-top: none;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  @media (orientation: landscape) {
    display: none;
  }

  @media ${TABLET_PORTRAIT} {
    display: none;
  }
`;

const SignupNavButton = styled(MobileFooterNavButton)`
  color: #75ea3d !important;
`;
